import './TheaterSeat.css';

/** MST3K-style solid seat-back silhouette (viewed from behind, facing the screen). */
export default function TheaterSeat({
  row,
  col,
  occupied = false,
}: {
  row: number;
  col: number;
  occupied?: boolean;
}) {
  return (
    <div
      className={`tt-seat tt-seat-row-${row}${occupied ? ' is-occupied' : ''}`}
      data-seat={`${row}:${col}`}
      aria-hidden
    >
      <svg className="tt-seat-svg" viewBox="0 0 80 40" role="img">
        {/* Short rounded backrest hump. Covers shoulders only. */}
        <path
          className="tt-seat-hump"
          d="M2 40 V18
             C2 7, 14 2, 40 2
             C66 2, 78 7, 78 18
             V40 Z"
        />
        {/* Soft screen wash on the top edge of the seat back */}
        <path
          className="tt-seat-rim"
          d="M10 16 C18 6, 62 6, 70 16"
          fill="none"
          strokeWidth="3"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}
